// run-command-prompt-decision-options-contract-section.ts — V2-1 (spec V2
// §4.1, I1 E3).
//
// Mục output contract V2 cho câu `needs_decision`: `options[].id`,
// `recommended_option_id`, `boundary_claims`. In ở MỌI mode (ask lẫn auto) —
// cặp id→nhãn là thứ người trả lời bằng id và sổ quyết định dựa vào, không
// riêng gì auto. Một mục `## ` riêng với tiêu đề CỐ ĐỊNH, đặt ngay trước
// "## Output contract (BẮT BUỘC)": golden I1 (b) bỏ đúng mục này theo tiêu đề
// (E3) và phần còn lại của prompt giữ byte-identical baseline.

/** Tiêu đề cố định — golden I1 lọc theo chuỗi này (E3); đổi chữ là đổi hợp đồng. */
export const DECISION_OPTIONS_CONTRACT_SECTION_TITLE =
  "## Output contract V2 — lựa chọn khi needs_decision (BẮT BUỘC)";

/** 7 cờ ranh giới (spec §4.1) — nguồn duy nhất cho prompt và luật auto. */
export const BOUNDARY_CLAIM_FLAGS = [
  "changes_product_behavior",
  "out_of_scope",
  "touches_resources",
  "touches_money_or_quota",
  "touches_secret_or_deploy",
  "touches_base_ref_or_approver",
  "touches_personal_data_or_compliance",
] as const;

export function renderDecisionOptionsContractSection(): string[] {
  return [
    "",
    DECISION_OPTIONS_CONTRACT_SECTION_TITLE,
    "- Khi outcome = needs_decision: MỖI phần tử options[] PHẢI có `id` (chuỗi khớp ^[a-z0-9-]{1,32}$, duy nhất trong result) và `label` (nhãn cho người đọc). Người và controller trả lời bằng id; thiếu/trùng/sai dạng id ⇒ câu hỏi về lại dạng theo nhãn và KHÔNG BAO GIỜ được tự áp.",
    "- `recommended_option_id`: id của lựa chọn bạn khuyến nghị — phải là một id trong options[].",
    `- \`boundary_claims\`: khai THẬT cả 7 cờ boolean ${BOUNDARY_CLAIM_FLAGS.map((f) => `\`${f}\``).join(", ")} cùng \`reversible\` (boolean). Chỉ khi mission đã ủy nhiệm (BLUEPRINT duyệt G0 có \`decision_policy: auto\`), \`reversible: true\` và cả 7 cờ \`false\` thì controller MỚI xét tự áp khuyến nghị — và vẫn tự kiểm lại (không tin lời khai); còn lại thì hỏi người.`,
    "- Mỗi needs_decision chỉ MỘT quyết định: options[] là các phương án của cùng một câu hỏi. Còn ≥ 2 quyết định mở ⇒ hỏi riêng từng câu, câu thuộc phạm vi ủy nhiệm (mọi cờ boundary_claims = false) trước, câu đổi hành vi ở attempt sau. Một câu đã chốt chỉ chốt đúng option được chọn — quyết định chưa có câu riêng vẫn là quyết định mở.",
    '- Quyết định đã chốt (của người hoặc tự áp) quay lại ở mục "Quyết định đã chốt cho ticket này" theo option id — làm theo, KHÔNG hỏi lại câu đó.',
  ];
}
